import { loadLines } from '@/stores/load/loadLines'
import { useLoad } from './useLoad'

export function useLoadLines({ level = 0 }: { level?: number } = {}) {
	return useLoad(loadLines, { level })
}
